import React, { useCallback } from 'react';
import { Pane, Popup, ToggleButton } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { ModelTypeSelector } from '@leverege/ui-plugin';
import Variantizers from "../../../../variantizer/Variantizers.js";
import ValueVariantizer from "../../../../variantizer/ValueVariantizer.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tfIcon
} = I18N.ns('ui-attributes.detail.customText.textEditor.editors.widgets.VariantPicker');
const DEFAULT_VALUE = ValueVariantizer.create({
  variant: null
});
export default {
  matches: {
    use: 'MenuBar',
    client: 'CustomTextModelEditor'
  },
  id: 'Rich.Text.Editor.Variant',
  handles: () => true,
  layout: {
    sort: 'L'
  },
  customComponent: VariantPicker
};
function VariantPicker(props) {
  const {
    context: {
      editor,
      objectType,
      ...rest
    }
  } = props;
  let value;
  try {
    value = editor.getAttributes('levText')?.variant;
    if (value) {
      value = JSON.parse(value);
    }
  } catch (err) {}
  const onChange = useCallback(({
    value
  }) => {
    if (value) {
      editor.chain().focus().setVariant(value).run();
    } else {
      editor.chain().focus().unsetVariant().run();
    }
  }, [editor]);
  const renderTrigger = useCallback(({
    ref,
    onToggle,
    isOpened
  }) => {
    return /*#__PURE__*/_jsx(ToggleButton, {
      title: t('title'),
      disabled: !editor.can().setVariant?.() || editor.isActive('code'),
      variant: "customTextVariant|customText",
      value: !!editor.getAttributes('levText').variant,
      onChange: (...args) => {
        if (!value) {
          onChange({
            value: {
              ...DEFAULT_VALUE
            }
          });
        }
        onToggle(...args);
      },
      domRef: ref,
      icon: tfIcon('button', 'fa fa-tag')
    });
  }, [editor, value, onChange]);
  return /*#__PURE__*/_jsx(Popup, {
    trigger: renderTrigger,
    children: /*#__PURE__*/_jsx(Pane, {
      variant: "card",
      children: ModelTypeSelector.createSelectorAndEditor({
        editorProps: {
          ...rest,
          objectType
        },
        modelKey: 'variantizer',
        values: Variantizers.getVariantizersFor(objectType),
        value,
        onChange
      })
    })
  });
}